module.exports = __webpack_public_path__ + "static/img/03.46cdcdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour1/03.jpg
// module id = FyJB
// module chunks = 0